/* bmcA.js (group A, whole-store Josh pass 2026-09-28). Store pages only (loaded from snippets/bmcA-store.liquid).
   Search hints + recent searches (localStorage bmcA_recent), zero-results ideas, search count, back to top,
   saved for later (localStorage bmcA_saved). Nothing here runs on bmc-landing* pages. */
(function () {
  'use strict';
  var D = {};
  try { D = JSON.parse(document.getElementById('bmcA-data').textContent) || {}; } catch (e) { D = {}; }
  var SKIP = {};
  (D.skip || []).forEach(function (h) { if (h) SKIP[h] = 1; });
  var SEARCH = D.search || '/search';
  function store(k, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null');
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
    return v;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function searchUrl(q) { return SEARCH + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function say(msg) { var l = document.getElementById('bmcA-live'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 50); } }

  /* ---------- recent searches ---------- */
  var RKEY = 'bmcA_recent';
  function recent() { var r = store(RKEY); return Array.isArray(r) ? r.filter(function (x) { return typeof x === 'string'; }) : []; }
  function addRecent(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (q.length < 2) return;
    var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q);
    store(RKEY, r.slice(0, 5));
  }
  var termsEl = document.querySelector('[data-bmcA-terms]');
  if (termsEl) addRecent(termsEl.getAttribute('data-bmcA-terms'));
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[role="search"]')) { var i = f.querySelector('input[name="q"]'); if (i) addRecent(i.value); }
  }, true);
  function paintRecent() {
    var r = recent();
    document.querySelectorAll('[data-bmcA-shints]').forEach(function (p) {
      var box = p.querySelector('[data-bmcA-recent]'), ul = p.querySelector('[data-bmcA-recent-list]');
      if (!box || !ul) return;
      ul.innerHTML = r.map(function (q) { return '<li><a class="bmcA-shints__chip" href="' + esc(searchUrl(q)) + '">' + esc(q) + '</a></li>'; }).join('');
      box.hidden = !r.length || (p.getAttribute('data-bmcA-shints') === 'page' && !p.bmcAEmpty);
    });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-bmcA-recent-clear]');
    if (c) { e.preventDefault(); store(RKEY, []); paintRecent(); say('Recent searches cleared'); }
  });
  document.querySelectorAll('[data-bmcA-shints]').forEach(function (p) {
    var where = p.getAttribute('data-bmcA-shints');
    var root = p.closest('predictive-search, search-form, details-modal, .template-search__search') || p.parentElement;
    var input = root && root.querySelector('input[type="search"]');
    if (!input) return;
    function empty() { return !input.value.trim(); }
    if (where === 'modal') {
      var up = function () { p.hidden = !empty(); };
      input.addEventListener('input', up); input.addEventListener('focus', function () { paintRecent(); up(); }); up();
    } else if (where === 'inline') {
      var focused = false;
      var up2 = function () { p.hidden = !(focused && empty()); };
      p.addEventListener('mousedown', function (e) { if (!(e.target.closest && e.target.closest('a,button'))) e.preventDefault(); });
      input.addEventListener('focus', function () { focused = true; paintRecent(); up2(); });
      input.addEventListener('input', up2);
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { focused = false; up2(); } });
      root.addEventListener('focusout', function () { setTimeout(function () { focused = root.contains(document.activeElement); up2(); }, 200); });
    } else {
      var up3 = function () { p.bmcAEmpty = empty(); paintRecent(); };
      input.addEventListener('input', up3); up3();
    }
  });
  paintRecent();

  /* ---------- zero results: ideas from the query itself ---------- */
  var ideas = document.querySelector('[data-bmcA-ideas]');
  if (ideas) {
    var q = String(ideas.getAttribute('data-q') || '').toLowerCase().trim();
    var VOC = ['theory', 'guitar', 'piano', 'mixing', 'mastering', 'game', 'games', 'music', 'composition', 'compose', 'composer', 'composing',
      'orchestration', 'counterpoint', 'songwriting', 'songwriter', 'coloring', 'journal', 'practice', 'mindset', 'money', 'looping',
      'notation', 'instrumental', 'inspiration', 'acoustic', 'electric', 'beginners', 'beginner', 'workbook', 'release', 'roadmap',
      'scoring', 'challenge', 'book', 'books', 'course', 'courses', 'symbols', 'instruments', 'laws', 'learning', 'grooves', 'success',
      'magic', 'odyssey', 'read', 'reading', 'chords', 'harmony', 'melody', 'video', 'production', 'business',
      'lesson', 'lessons', 'class', 'classes', 'online', 'teacher', 'drawing', 'kids'];
    var lev = function (a, b) {
      var m = a.length, n = b.length, d = [], i, j;
      for (i = 0; i <= m; i++) { d[i] = [i]; }
      for (j = 1; j <= n; j++) { d[0][j] = j; }
      for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      return d[m][n];
    };
    var words = q.replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(Boolean);
    var fixed = [], changed = false, unknown = [];
    words.forEach(function (w) {
      if (VOC.indexOf(w) > -1 || w.length < 3 || /\d/.test(w)) { fixed.push(w); return; }
      var best = null, bd = 99;
      VOC.forEach(function (v) { var dd = lev(w, v); if (dd < bd) { bd = dd; best = v; } });
      if (best && bd <= (w.length > 5 ? 2 : 1)) { fixed.push(best); changed = true; } else { fixed.push(w); unknown.push(w); }
    });
    var out = [];
    if (changed) out.push('Did you mean <a href="' + esc(searchUrl(fixed.join(' '))) + '">' + esc(fixed.join(' ')) + '</a>?');
    var clean = fixed.join(' ').replace(/[^a-z\s]/g, ' ').replace(/\s+/g, ' ').trim();
    if (clean && /[^a-z\s]/.test(q)) out.push('Leave out numbers and symbols: <a href="' + esc(searchUrl(clean)) + '">' + esc(clean) + '</a>.');
    var longw = fixed.filter(function (w) { return w.length >= 3 && !/\d/.test(w); });
    if (words.length >= 3 && longw.length) out.push('Use fewer words. Try just one: ' + longw.slice(0, 4).map(function (w) { return '<a href="' + esc(searchUrl(w)) + '">' + esc(w) + '</a>'; }).join(', ') + '.');
    if (q.replace(/\s/g, '').length < 3) out.push('Type at least 3 letters.');
    if (!out.length && unknown.length) out.push('&ldquo;' + esc(unknown.join(' ')) + '&rdquo; is not in any course or book title. Check the spelling, or pick a topic below.');
    if (out.length) ideas.innerHTML = '<ul>' + out.map(function (h) { return '<li>' + h + '</li>'; }).join('') + '</ul>';
  }

  /* ---------- search count matches what is listed ---------- */
  function fixCount() {
    var c = document.querySelector('[data-bmcA-count]');
    if (!c) return;
    var n = parseInt(c.getAttribute('data-bmcA-count'), 10), nat = parseInt(c.getAttribute('data-bmcA-count-native'), 10);
    if (isNaN(n) || n === nat) return;
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.getAttribute('data-bmcA-n') === String(n)) return;
      el.textContent = el.textContent.replace(/\d[\d,.]*/, String(n)).replace(/\bresults?\b/, n === 1 ? 'result' : 'results');
      el.setAttribute('data-bmcA-n', String(n));
    });
  }
  fixCount();
  var grid = document.getElementById('ProductGridContainer');
  if (grid && window.MutationObserver) new MutationObserver(function () { setTimeout(fixCount, 50); }).observe(grid, { childList: true, subtree: true });

  /* ---------- back to top ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bmcA-top]');
    if (!a) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var m = document.getElementById('MainContent');
    if (m) setTimeout(function () { try { m.focus({ preventScroll: true }); } catch (x) {} }, reduce ? 0 : 450);
  });

  /* ---------- saved for later ---------- */
  var WKEY = 'bmcA_saved';
  var HEART = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var FKEY = 'bmcF-saved'; // group F's /cart "Save for later" lines: shown in the same list so the shopper has one list
  function clean(s) { return Array.isArray(s) ? s.filter(function (x) { return x && x.h && !SKIP[x.h]; }) : []; }
  function saved() { return clean(store(WKEY)); }
  function savedF() { return clean(store(FKEY)); }
  function all() { var m = saved(), seen = {}; m.forEach(function (x) { seen[x.h] = 1; }); return m.concat(savedF().filter(function (x) { return !seen[x.h]; })); }
  function isSaved(h) { return all().some(function (x) { return x.h === h; }); }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : null; }
  function visibleText(els) { for (var i = 0; i < els.length; i++) { if (els[i].offsetParent !== null && els[i].textContent.trim()) return els[i].textContent.replace(/\s+/g, ' ').trim(); } return ''; }
  function setBtn(b, on) {
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var t = b.getAttribute('data-bmcA-title') || 'this item';
    b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + t + (on ? ' from your saved list' : ' for later'));
    var lab = b.querySelector('.bmcA-save__label'), want = on ? 'Saved' : 'Save for later';
    if (lab && lab.textContent !== want) lab.textContent = want;
  }
  function makeBtn(item, text) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bmcA-save' + (text ? ' bmcA-save--text' : '');
    b.setAttribute('data-bmcA-item', JSON.stringify(item));
    b.setAttribute('data-bmcA-title', item.t || 'this item');
    b.innerHTML = HEART + (text ? '<span class="bmcA-save__label">Save for later</span>' : '');
    setBtn(b, isSaved(item.h));
    return b;
  }
  function scanCards(root) {
    (root || document).querySelectorAll('.card-wrapper, .bmc-item').forEach(function (card) {
      if (card.querySelector('.bmcA-save')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link && handleOf(link.getAttribute('href'));
      if (!h || SKIP[h]) return;
      var titleEl = card.querySelector('.card__heading a, .card__heading, .bmc-item__t');
      var img = card.querySelector('img');
      var price = card.classList.contains('bmc-item') ? ((card.querySelector('.bmc-item__p') || {}).firstChild || {}).textContent || '' : visibleText(card.querySelectorAll('.price-item'));
      var item = { h: h, t: (titleEl ? titleEl.textContent : link.textContent).replace(/\s+/g, ' ').trim(), u: '/products/' + h,
        i: img ? (img.currentSrc || img.src || '') : '', p: String(price).replace(/\s+/g, ' ').trim() };
      var host = card.querySelector('.card__inner') || card;
      host.appendChild(makeBtn(item, false));
    });
  }
  function scanProduct() {
    if (!D.product || !D.product.h || SKIP[D.product.h]) return;
    if (document.querySelector('.bmcA-save--text')) return;
    var bar = document.querySelector('.bmc-buybar, .bmcE-bar__buy');
    if (bar) { var f = bar.querySelector('form'); bar.insertBefore(makeBtn(D.product, true), f || null); return; }
    var btns = document.querySelector('#MainContent .product-form__buttons');
    if (btns) btns.parentNode.insertBefore(makeBtn(D.product, true), btns.nextSibling);
  }
  var panel = document.getElementById('bmcA-wish');
  var opener = null;
  function paint() {
    var s = all();
    document.querySelectorAll('[data-bmcA-wish-count]').forEach(function (n) { if (n.textContent !== String(s.length)) n.textContent = String(s.length); n.hidden = !s.length; });
    document.querySelectorAll('.bmcA-save').forEach(function (b) { try { setBtn(b, isSaved(JSON.parse(b.getAttribute('data-bmcA-item')).h)); } catch (e) {} });
    if (!panel) return;
    var ul = panel.querySelector('[data-bmcA-wish-list]'), em = panel.querySelector('[data-bmcA-wish-empty]');
    ul.innerHTML = s.map(function (x) {
      return '<li class="bmcA-wish__item">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>') +
        '<div><a href="' + esc(x.u) + '">' + esc(x.t) + '</a>' + (x.p ? '<span class="bmcA-wish__price">' + esc(x.p) + '</span>' : '') +
        '<a class="bmcA-wish__view" href="' + esc(x.u) + '">View it now</a></div>' +
        '<button type="button" class="bmcA-wish__rm" data-bmcA-rm="' + esc(x.h) + '">Remove</button></li>';
    }).join('');
    if (em) em.hidden = !!s.length;
  }
  function toggle(item) {
    var s = saved(), i = -1, f = savedF(), fi = -1;
    s.forEach(function (x, k) { if (x.h === item.h) i = k; });
    f.forEach(function (x, k) { if (x.h === item.h) fi = k; });
    if (fi > -1) { f.splice(fi, 1); store(FKEY, f); }
    if (i > -1) s.splice(i, 1); else if (fi === -1) s.unshift({ h: item.h, t: item.t, u: item.u, i: item.i, p: item.p });
    store(WKEY, s.slice(0, 40));
    if (fi > -1 && i === -1) i = fi;
    paint();
    say(i > -1 ? 'Removed from your saved list' : 'Saved for later. Open the heart to see your list.');
  }
  function openPanel(from) {
    if (!panel) return;
    opener = from || null;
    var dd = document.querySelector('header-drawer details[open] > summary');
    if (dd) dd.click();
    paint();
    panel.hidden = false; panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bmcA-lock');
    var pp = panel.querySelector('.bmcA-wish__panel'); if (pp) pp.focus();
  }
  function closePanel() {
    if (!panel || panel.hidden) return;
    panel.hidden = true; panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bmcA-lock');
    if (opener && opener.focus && opener.offsetParent !== null) opener.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var sv = t.closest('.bmcA-save');
    if (sv) { e.preventDefault(); e.stopPropagation(); try { toggle(JSON.parse(sv.getAttribute('data-bmcA-item'))); } catch (x) {} return; }
    var op = t.closest('[data-bmcA-wish-open]');
    if (op) { e.preventDefault(); openPanel(op); return; }
    if (t.closest('[data-bmcA-wish-close]')) { e.preventDefault(); closePanel(); return; }
    var rm = t.closest('[data-bmcA-rm]');
    if (rm) { e.preventDefault(); toggle({ h: rm.getAttribute('data-bmcA-rm') }); var pp = panel && panel.querySelector('.bmcA-wish__panel'); if (pp) pp.focus(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!panel || panel.hidden) return;
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('storage', function (e) { if (e.key === WKEY || e.key === FKEY) paint(); });
  scanCards(); scanProduct(); paint();
  var main = document.getElementById('MainContent');
  if (main && window.MutationObserver) {
    var tmr = null;
    new MutationObserver(function () { clearTimeout(tmr); tmr = setTimeout(function () { scanCards(main); scanProduct(); paint(); }, 250); })
      .observe(main, { childList: true, subtree: true });
  }
})();
